import { Instance, types } from "mobx-state-tree";
import {
  IMessageWidgetConfig,
  MessageWidgetConfig,
  parseMessageWidgetConfig
} from "./MessageWidgetConfig";
import { NO_TAG_GROUP_ID, TagGroupMessageWidgetsMap } from "./TagGroupMessageWidgetsMap";

export const LocaleMessageWidgetsMap = types
  .model("LocaleMessageWidgetsMap", {
    locale: types.identifier,
    configsPerGroup: types.map(TagGroupMessageWidgetsMap)
  })
  .views((self) => {
    const views = {
      getConfigsAssignedForGroup(tagGroupId: string): IMessageWidgetConfig[] {
        return self.configsPerGroup.get(tagGroupId)?.configs || [];
      },

      getConfigsForGroup(tagGroupId?: string): IMessageWidgetConfig[] {
        const msgWidgetsWithoutTag = self.configsPerGroup.get(NO_TAG_GROUP_ID)?.configs || [];

        if (!tagGroupId) {
          return msgWidgetsWithoutTag;
        }

        const msgWidgetsForTagGroup =
          self.configsPerGroup.get(tagGroupId || NO_TAG_GROUP_ID)?.configs || [];
        return [...msgWidgetsWithoutTag, ...msgWidgetsForTagGroup];
      },

      getAllConfigs(): IMessageWidgetConfig[] {
        return Array.from(self.configsPerGroup.keys()).reduce<IMessageWidgetConfig[]>(
          (acc, tagGroupId) => {
            return [...acc, ...(self.configsPerGroup.get(tagGroupId)?.configs || [])];
          },
          []
        );
      }
    };

    return views;
  })
  .actions((self) => {
    const actions = {
      setConfigs(configs: IMessageWidgetConfig[]) {
        configs.forEach((widgetConfig) => {
          const tagGroupId = widgetConfig.tagGroupId || NO_TAG_GROUP_ID;
          const currentTagGroupConfigs = self.configsPerGroup.get(tagGroupId);

          if (currentTagGroupConfigs === undefined) {
            const tagGroupMap = TagGroupMessageWidgetsMap.create({ tagGroupId });
            tagGroupMap.setConfigs([widgetConfig]);

            self.configsPerGroup.set(tagGroupId, tagGroupMap);
          } else {
            currentTagGroupConfigs.setConfigs([
              ...currentTagGroupConfigs.configs,
              MessageWidgetConfig.create(parseMessageWidgetConfig(widgetConfig))
            ]);

            self.configsPerGroup.set(tagGroupId, currentTagGroupConfigs);
          }
        });
      }
    };

    return actions;
  });

export interface ILocaleMessageWidgetsMap extends Instance<typeof LocaleMessageWidgetsMap> {}
